module.exports = __webpack_public_path__ + "img/successfully_received.60b9f51.svg";